jQuery(document).ready(function($) {
    const $channelSelectorModel = $('#channel-selector-model');
    const $channelSelectorDimmer = $('#channel-selector-dimmer');
    const $mobileBreakpoint = 885; // Set the breakpoint for small screens.
    const $menuRegion = $('.menu__region');
    const $megaMenuWrap = $('#mega-menu-wrap-jh-header-mega-menu');

    $menuRegion.addClass('channel-selector-is-closed');

    // Attach the event listener to a static parent element, using event delegation because the cloned
    // element didn't exist yet in the dom when it was cloned.
    $('body').on('click', '.channel-selector-trigger', function() {
        const $bodyWidth = $('body').width();

        $menuRegion.addClass('channel-selector-is-open');
        $menuRegion.removeClass('channel-selector-is-closed');

        $megaMenuWrap.css( 'z-index', 1 );


        if ($bodyWidth < $mobileBreakpoint) {
            // Center the model in the middle of the screen for small screens.
            $channelSelectorModel.css({
                display: 'block',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                position: 'fixed',
                opacity: 1

            });
        } else {
            // Calculate the position of the button
            const $buttonOffset = $(this).offset();
            const $buttonWidth = $(this).outerWidth();
            const $buttonHeight = $(this).outerHeight();
            const $modelWidth = $channelSelectorModel.outerWidth();
            // Calculate the right position for the model to align its right side with the button's right side
            const $modelRightPosition = $bodyWidth - ($buttonOffset.left + $buttonWidth);

            // Position the model as before for screens 885px or wider
            $channelSelectorModel.css({
                display: 'block', // Show the model
                top: $buttonOffset.top + $buttonHeight + 'px', // Position it below the button
                right: $modelRightPosition + 'px', // Align the right side of the model with the right side of the button
                transform: '', // Clear any transform applied from smaller screens
                position: 'absolute', // Position relative to the nearest positioned ancestor instead of the viewport
                opacity: 1
            });
        }

        // Trigger the animation to slide in the model and fade in the dimmer
        $channelSelectorDimmer.css('display', 'block').animate({ opacity: 1 }, 250);
    });

    // Function to close the model and hide the dimmer
    function closeModel() {
        const $bodyWidth = $('body').width(); // Use the width of the body element

        $menuRegion.removeClass('channel-selector-is-open');
        $menuRegion.addClass('channel-selector-is-closed');

        // Got into a bit of a z-index war with all these little popups and models in the header. ☹️
        $megaMenuWrap.css( 'z-index', 'unset' );

        if ( $bodyWidth < $mobileBreakpoint ) {
            $channelSelectorModel.animate({opacity: 0}, 150, function () {
                $(this).css('display', 'none'); // Hide the model after animation completes
            });
            $channelSelectorDimmer.animate({opacity: 0}, 150, function () {
                $(this).css('display', 'none'); // Hide the dimmer after animation completes
            });
        } else {
            $channelSelectorModel.css({
                right: -$channelSelectorModel.outerWidth() + 'px', // Slide the model out
                transform: '', // Clear any transform to reset state
                position: 'absolute' // Reset position to default
            });

            $channelSelectorDimmer.animate({opacity: 0}, 150); // Fade out the dimmer

            setTimeout(function() {
                $channelSelectorModel.css('display', 'none'); // Hide the model
                $channelSelectorDimmer.css('display', 'none'); // Hide the dimmer
            }, 750);
        }


    }

    // Close the model when the dimmer is clicked
    $channelSelectorDimmer.on('click', closeModel);

    // Close the model when the Menu Region is clicked
    $('body').on('click', '.channel-selector-is-open', function() {

            closeModel();

    });

    // Close the model when the close button inside the model is clicked
    $('.modal-box-close').on('click', closeModel);

    // Close the model when the Escape key is pressed
    $(document).on('keydown', function(e) {
        if (e.key === 'Escape') {
            closeModel();
        }
    });
});